module.exports = __webpack_public_path__ + "static/media/het_suikervogeltje.ce5fe7c7.jpg";